import { render, staticRenderFns } from "./Ido.vue?vue&type=template&id=e7dd2c0c&"
import script from "./Ido.vue?vue&type=script&lang=js&"
export * from "./Ido.vue?vue&type=script&lang=js&"
import style0 from "./Ido.vue?vue&type=style&index=0&id=e7dd2c0c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports